import { MicroFrontend } from '@praxis/component-microfrontend'
import { LoadingProfileMfe } from '../common/LoadingProfileMfe' // Import Redux store
import store from '../../store'
import apiConfig from '../../globalConfig/apiConfig'

export const IauManageMfe = ({ ...rest }) => {
  const path = `${apiConfig.remotes.iau}/remoteEntry.js`

  return (
    <>
      <div className="dummy-header" />
      <MicroFrontend
        module="./Manage"
        src={path}
        mfeProp={{ source: 'lphome' }}
        Loading={LoadingProfileMfe}
        parentStore={store}
        {...rest}
      ></MicroFrontend>
    </>
  )
}
